export default "__VITE_ASSET__BrSt4g2V__"